export default "__VITE_ASSET__D_ePVQld__"